import React from 'react';
import {
    Box,
    Typography,
} from '@mui/material';
import CustomDivider from '../../shared/utils/CustomDivider';
import * as Yup from "yup";
import { Formik, Field, Form } from "formik";
import RatingFormField from '../../shared/components/FormFields/RatingFormField';
import { TextFormField } from '../../shared/components/FormFields/TextFormField';
import { CustomButtonContained, CustomButtonOutline } from "../../shared/utils/CustomButton";


export const ReviewRating = () => {
    const validationSchema = Yup.object().shape({
        rating: Yup.number()
            .min(0, "Please select at least 1 star") // Ensures at least 1 star is selected
            .max(5, "Rating cannot exceed 5 stars")
            .required("Rating is required"),

        message: Yup.string()
            .trim()
        // .min(10, "Feedback must be at least 10 characters")
        // .max(300, "Feedback cannot exceed 300 characters")
        // .required("Feedback is required"),
    });
    const initialValues = {
        rating: 0,
        message: ""
    };
    const handleSubmit = () => {
    }
    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
            {(formik) => (
                <Form>
                    <Typography variant="h5" mb={1} >Submit Your Rating</Typography>
                    <RatingFormField name="rating" />
                    <CustomDivider orientation='horizontal' />
                    <Typography variant="h5" mb={1}>Write Your Review</Typography>
                    <Field
                        name="message"
                        component={TextFormField}
                        placeholder={"Tell us about the course and your experience"}
                        bgcolor={"#F1F1F1"}
                        border={"none"}
                        multiline
                        rows={6}
                    />

                    <Box mt={2} display={"flex"} justifyContent={"end"} gap={3}>
                        {(formik.values.rating !== 0 || formik.values.message.trim() !== "") && (
                            <CustomButtonOutline
                                buttonText="Cancel"
                                onClick={() => formik.resetForm()}
                                 padding={"15px 25px"}
                            />
                        )}
                        <CustomButtonContained buttonText="Submit"  padding={"15px 25px"} />

                    </Box>

                </Form>
            )}
        </Formik>
    )
}
